<template>
  <a-card :bordered="false" title="智能海报" :bodyStyle="{paddingTop:'0px'}"
          :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="海报名称" v-bind="searchItemLayout" style="margin-bottom:0;">
            <a-input-search placeholder="请输入海报名称" @search="onSearch"/>
          </a-form-item>
          <a-form-item v-bind="formItemLayoutBtns" style="margin-left:2%;margin-bottom:0;">
            <a-button type="primary" icon="plus" @click="handleClick(0)">新建</a-button>
          </a-form-item>
        </search-list>
      </search-header>
      <a-row style="margin-bottom:10px;">
        <a-col :span="12" :offset="12" style="text-align:right;">海报默认文案及供应商海报引用 &nbsp;&nbsp;&nbsp;<a
          @click="settingText">设置</a></a-col>
      </a-row>
    </a-form>
    <custom-page-table
      ref="table"
      rowKey="posterId"
      :query-params="queryParams"
      query-path="poster/findPosterList"
      base-key="serviceUrl"
      :columns="columns"
    >

      <div slot="action" slot-scope="data">
        <a @click="handleClick(data.record.posterId)">修改</a>
        <span v-if="data.record.posterStatus==0">
          <a-divider type="vertical"/>
          <a-popconfirm
            title="是否要删除当前海报？"
            @confirm="onDelete(data.record.posterId)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </div>
    </custom-page-table>
    <!-- 设置海报 -->
    <a-modal title="设置海报" :visible="dialogPosterVisible" :footer="null" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="海报名称" prop="posterName">
          <a-input v-model="ruleForm.posterName" :maxLength="20" placeholder="不超过20个字"/>
        </a-form-model-item>
        <a-form-model-item label="海报模板">
          <a-select allowClear
                    style="width: 100%"
                    :disabled="ruleForm.posterId!=0"
                    v-model="ruleForm.posterCode"
                    placeholder="请选择"
                    @change="changePoster"
          >
            <a-select-option v-for="item in posterList" :key="item.key" :value="item.key">{{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="状态" prop="posterStatus">
          <a-radio-group name="radioGroup" v-model="ruleForm.posterStatus">
            <a-radio :value="1">使用</a-radio>
            <a-radio :value="0">不使用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="checkTypeList.length>0" label="使用品类" prop="posterProUse">
          <a-checkbox-group v-model="ruleForm.posterProUse">
            <a-checkbox v-for="(item,index) in checkTypeList" :key="index" :value="item">
              {{ Number(item) | productTypeName }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="onSubmit" :loading="submitLoading">保存设置</a-button>
          <a-button style="margin-left: 10px;" @click="dialogPosterVisible = false">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 文案设置 -->
    <a-modal title="文案设置" :visible="dialogTextVisible" :footer="null" @cancel="handleTextCancel">
      <p>以下信息设置后，自动生成的海报将以此为准(10字内)</p>
      <a-form-model ref="formData" :model="formData" :rules="rulesData"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="广告语" prop="posterAdvertisingSlogan">
          <a-input v-model="formData.posterAdvertisingSlogan" :maxLength="10" placeholder="旅游出行，找我就行"/>
        </a-form-model-item>
        <a-form-model-item label="扫码提示" prop="posterScanPrompt">
          <a-input v-model="formData.posterScanPrompt" :maxLength="10" placeholder="扫码查看详情与预订"/>
        </a-form-model-item>
        <a-form-model-item label="供应商海报" prop="openMerchantPoster">
          <a-radio-group v-model="formData.openMerchantPoster">
            <a-radio :value="0">不使用</a-radio>
            <a-radio :value="1">默认使用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="公众号吸粉" prop="openWeixinSuction">
          <a-radio-group v-model="formData.openWeixinSuction">
            <a-radio :value="0">关闭</a-radio>
            <a-radio :value="1">开启</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
          <a-button style="margin-left: 10px;" @click="dialogTextVisible = false">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'SmartPoster',
  mixins: [searchForm],
  components: {},
  data() {
    return {
      submitLoading: false,
      dialogTextVisible: false,
      formData: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        posterAdvertisingSlogan: '',//广告语
        posterScanPrompt: '',//扫码提示
        openMerchantPoster: 1,
        openWeixinSuction: 0
      },
      ruleForm: {
        merchantId: 0,
        platformId: 0,
        posterCode: undefined,//海报模板
        posterId: 0,//海报Id
        posterName: '',//海报名称
        posterProUse: [],//使用品类
        posterStatus: ''//使用状态
      },
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      checkTypeList: [],
      dialogPosterVisible: false,
      imgDialogVisible: false,
      loading: false,
      imageUrl: '',
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        posterName: '',
        platformId: this.getPlatformConfig().platformId
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'posterId'
        },
        {
          title: '海报名称',
          dataIndex: 'posterName'
        },
        {
          title: '使用模板',
          dataIndex: 'posterCodeStr'
        },
        {
          title: '使用品类',
          dataIndex: 'posterProUse'
        },
        {
          title: '创建时间',
          dataIndex: 'posterCreateTime'
        },
        {
          title: '状态',
          dataIndex: 'posterStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '170px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      posterList: [],
      rules: {
        posterName: [
          { required: true, message: '请输入海报名称', trigger: 'blur' }
        ],
        posterStatus: [
          { required: true, message: '请选择海报状态', trigger: 'change' }
        ],
        posterProUse: [
          { type: 'array', required: true, message: '请至少选择使用品类', trigger: 'change' }
        ]
      },
      formItemLayoutBtns: {
        labelCol: {
          span: 0
        },
        wrapperCol: {
          span: 24
        }
      },
      submitFormData: '',
      rulesData: {
        posterAdvertisingSlogan: [
          { required: true, message: '请输入广告语', trigger: 'blur' }
        ],
        posterScanPrompt: [
          { required: true, message: '请输入扫码提示', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [{ name: 'SmartPoster', title: '我的模板' }, {
      name: 'PosterTemplate',
      title: '海报模板'
    }])
  },
  mounted() {

  },
  methods: {
    onSearch(value) {
      this.queryParams.posterName = value
      this.$refs.table.refresh(true)
    },
    handleTextCancel() {
      this.dialogTextVisible = false
    },
    handleCancel() {
      this.dialogPosterVisible = false
    },
    handleClick(id) {
      this.dialogPosterVisible = true
      this.getPosterTemplate(id)
    },
    // 获取海报模板
    getPosterTemplate(id) {
      this.getHttpServices().getServerApiService().post('poster/getPosterTemplate', {
        platformId: this.getPlatformConfig().platformId,
        merchantId: this.$store.getters.userInfo.merchantId
      }).then(res => {
        this.posterList = res
        this.getLogUtils().logWithTag('getPosterTemplate', res)
        this.getPosterDetails(id)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getPosterDetails(posterId) {
      if (posterId != 0) {
        this.getHttpServices().getServerApiService().get('poster/findPosterDetails?posterId=' + posterId).then(res => {
          this.getLogUtils().logWithTag('getPosterDetails', res)
          this.ruleForm = res
          this.ruleForm.posterProUse = res.posterProUse ? res.posterProUse.split(',') : []
          this.changePoster(this.ruleForm.posterCode)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.ruleForm = {
          merchantId: 0,
          platformId: 0,
          posterCode: '',//海报模板
          posterId: 0,//海报Id
          posterName: '',//海报名称
          posterProUse: [],//使用品类
          posterStatus: ''//使用状态
        }
        this.ruleForm.posterCode = this.posterList[0].key
        this.getLogUtils().logWithTag('posterCode', this.ruleForm.posterCode)
        this.changePoster(this.posterList[0].key)
      }
    },
    //选择海报
    changePoster(id) {
      let productType = ''
      try {
        productType = this.posterList.filter(item => {
          return item.key == id
        })[0].param
      } catch (err) {
        this.getLogUtils().logWithTag('err', err)
      }
      this.getLogUtils().logWithTag('productType', productType)
      if (productType != '') {
        this.checkTypeList = productType.split(',')
      } else {
        this.checkTypeList = []
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitLoading = true
      this.submitFormData.merchantId = this.$store.getters.userInfo.merchantId
      this.submitFormData.platformId = this.getPlatformConfig().platformId
      this.submitFormData.posterProUse = this.submitFormData.posterProUse.join(',')
      this.getHttpServices().getServerApiService().post('poster/editPoster', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('模板设置成功')
        this.dialogPosterVisible = false
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 查询
    settingText() {
      this.dialogTextVisible = true
      this.getHttpServices().getServerApiService().post('poster/getPosterProgram', {
        platformId: this.getPlatformConfig().platformId,
        merchantId: this.$store.getters.userInfo.merchantId
      }).then(res => {
        this.getLogUtils().logWithTag('settingText', res)
        this.formData.posterAdvertisingSlogan = res.posterProgramAdvertisingSlogan ? res.posterProgramAdvertisingSlogan : ''//广告语
        this.formData.posterScanPrompt = res.posterProgramScanPrompt ? res.posterProgramScanPrompt : ''//扫码提示
        this.formData.openMerchantPoster = res.openMerchantPoster ? Number(res.openMerchantPoster) : 1//供应商
        this.formData.openWeixinSuction = res.openWeixinSuction ? Number(res.openWeixinSuction) : 0//吸粉
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleSubmit() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.savePosterData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    // 文案设置
    savePosterData() {
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('poster/editPosterProgram', this.formData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('文案设置成功')
        this.dialogTextVisible = false
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 删除
    onDelete(posterId) {
      this.getHttpServices().getServerApiService().post('poster/delPoster?posterId=' + posterId).then(res => {
        this.getLogUtils().logWithTag('onDelete', res)
        this.$message.success('海报删除成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    }
  }
}
</script>
<style scoped lang="less">
.ant-btn + .ant-btn {
  margin-left: 5px;
}

.page {
  .image-box {
    width: 100%;
    height: 230px;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
    }
  }

  /deep/ .ant-card-meta-title {
    margin-bottom: 4px;
  }

  /deep/ .ant-card-meta-description {
    height: 44px;
    overflow: hidden;
    line-height: 22px;
  }
}
</style>